import { render } from "./EventImage.vue?vue&type=template&id=56da8f4c&scoped=true"
import script from "./EventImage.vue?vue&type=script&lang=js"
export * from "./EventImage.vue?vue&type=script&lang=js"

import "./EventImage.vue?vue&type=style&index=0&id=56da8f4c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56da8f4c"]])

export default __exports__